import { render, staticRenderFns } from "./Fund-cfh-Kq.vue?vue&type=template&id=60504236&scoped=true&"
import script from "./Fund-cfh-Kq.vue?vue&type=script&lang=js&"
export * from "./Fund-cfh-Kq.vue?vue&type=script&lang=js&"
import style0 from "./Fund-cfh-Kq.vue?vue&type=style&index=0&id=60504236&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60504236",
  null
  
)

export default component.exports